<template>
  <label class="toggle-switch">
    <input
      type="checkbox"
      :checked="modelValue"
      @change="emitChange"
      class="toggle-input"
    />
    <span class="toggle-slider" :style="{ backgroundColor: isActive ? color : '#ccc' }"></span>
  </label>
</template>
<script>
export default {
  name: 'ToggleButton',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: '#3370d1'
    },
    name: {
      type: String,
      default: ''
    },
    onchange: {
      type: Function,
      default: null
    }
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      isActive: this.value || this.modelValue
    };
  },
  watch: {
    value(newVal) {
      this.isActive = newVal;
    },
    modelValue(newVal) {
      this.isActive = newVal;
    }
  },
  methods: {
    emitChange() {
      this.isActive = !this.isActive;
      this.$emit('update:modelValue', this.isActive);
      this.$emit('change', this.isActive);
      if (this.onchange) {
        this.onchange(this.isActive);
      }
    }
  }
};
</script>
<style>
.toggle-switch {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  width: 60px;
  height: 30px;
}
.toggle-input {
  opacity: 0;
  width: 0;
  height: 0;
}
.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: background-color 0.3s ease;
  border-radius: 30px;
}
.toggle-switch:hover .toggle-slider {
  opacity: 0.8;
}
</style>
